/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Toggle_YearlyInputs */

const tr_pricing_toggle_yearly = /** @type {(inputs: Pricing_Toggle_YearlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yıllık`)
};

const en_pricing_toggle_yearly = /** @type {(inputs: Pricing_Toggle_YearlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yearly`)
};

const de_pricing_toggle_yearly = /** @type {(inputs: Pricing_Toggle_YearlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jährlich`)
};

const ru_pricing_toggle_yearly = /** @type {(inputs: Pricing_Toggle_YearlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ежегодно`)
};

/**
* | output |
* | --- |
* | "Yearly" |
*
* @param {Pricing_Toggle_YearlyInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const pricing_toggle_yearly = /** @type {((inputs?: Pricing_Toggle_YearlyInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Toggle_YearlyInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricing_toggle_yearly(inputs)
	if (locale === "de") return de_pricing_toggle_yearly(inputs)
	if (locale === "ru") return ru_pricing_toggle_yearly(inputs)
	return tr_pricing_toggle_yearly(inputs)
});